import styled from "styled-components";

export const CorperateInfoWidgetStyled = styled.div`
  .title {
    margin-bottom: 0.75rem;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .info_row {
    display: flex;
    align-items: flex-start;
    column-gap: 2rem;
    .info_left_col {
      flex: 1;
      min-width: 0;
    }
    .info_right_col {
      flex: 0 0 320px;
      max-width: 320px;
    }
  }
  .action_row {
    margin-top: 1.5rem;
    display: flex;
    justify-content: flex-end;
    column-gap: 1rem;
    .w130 {
      width: 130px;
    }
  }
`;

export const ModalBodyStyled = styled.div`
  position: relative;
  border-radius: 1rem;
  max-width: 720px;
  width: 100%;
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  padding: 20px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .btn_close_modal {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    z-index: 2;
  }
  .modal_title {
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .input_row {
    .f_left_col {
      width: 30%;
    }
    .f_right_col {
      width: 70%;
    }
  }
`;
